import { useCallback } from 'react'
import * as actions from 'client/actions/entityActions'
import { Dispatch } from 'redux'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'

export const useRemoveEntityMobileStyle = (
  dispatch: Dispatch<any>,
  entity: OldEntityInterface,
) => {
  return useCallback(
    (style: OldEntityInterface['styles']) => () => {
      const updatedEntity = {
        ...entity,
        mobileStyles: {
          ...entity.mobileStyles,
        },
      }

      delete updatedEntity.mobileStyles[style]
      dispatch(actions.update(updatedEntity))
    },
    [entity],
  )
}
